import { dynamicFailed } from "../hooks/useToast";
import { IComplaint } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchComplaints = async (): Promise<IComplaint[]> => {
  try {
    const response = await axiosClient.get<IComplaint[]>("/complaints");
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};

export const fetchComplaintById = async (
  id: number,
): Promise<IComplaint | null> => {
  try {
    const response = await axiosClient.get<IComplaint>(
      `/complaints/${id}`,
    );

    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message || "Something went wrong!";

    dynamicFailed(message);
    return null;
  }
};

